import ApiRouts from "../api/routes";
import {INITIALIZE} from "../redux/actions";
import store from "../redux/store";
import axios from "../api/axios";

export const Initialize = () => {
    const token = window.localStorage.getItem("edexLicenceToken")
        if (token) {
            axios.get(ApiRouts?.PROFILE).then((response) => {
                store.dispatch({
                    type: INITIALIZE,
                    data: {
                        initialized: true,
                        isAuthenticated: true,
                        user: response?.data?.data
                    }
                })
            }).catch((e)=>{
                store.dispatch({
                    type: INITIALIZE,
                    data: {
                        initialized: true,
                        isAuthenticated: false,
                        user: null
                    }
                })
            })

        }else {
            store.dispatch({
                type: INITIALIZE,
                data: {
                    initialized: true,
                    isAuthenticated: false,
                    user: null
                }
            })
        }



}
